import {
  ColumnDef,
  ColumnFiltersState,
  SortingState,
  VisibilityState,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Input } from "@/components/ui/input"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

import Modal from "@/components/Modal"
import SkeletonRow from "@/components/SkeletonRow"
// import { Badge } from "@/components/ui/badge"
import { useDebounce } from "@/hooks/useDebounce"
import api from "@/lib/axios"
// import { getListJalurJenis, getListUnitkerja } from "@/services/getData"
import {
  DataPendaftaranPesertaTalentscouting,
  // JalurJenis,
  PaginationData,
  // Unitkerja,
} from "@/types"
// import { LuListFilter } from "react-icons/lu"
import { useQuery } from "@tanstack/react-query"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { DetailPeserta } from "./DetailPeserta"
import FormFilter from "./FormFilter"
import { Pagination } from "./Pagination"
import { LuListFilter } from "react-icons/lu"

interface DataTableProps<
  TData extends DataPendaftaranPesertaTalentscouting,
  TValue
> {
  columns: ColumnDef<TData, TValue>[]
  data: TData[]
  paginationData: PaginationData<DataPendaftaranPesertaTalentscouting[]>
  isPending: boolean
}

interface DataPendaftaranCustom {
  id_data_pendaftaran: number
  nomor_pendaftaran: string
  nisn: string
  nama_lengkap: string
  handphone: string
  email: string
  jenis_kelamin: string
  npsn_sekolah: string
  nama_sekolah: string
  path_foto: string
  jalan: string
  nama_kecamatan: string
  nama_kabupaten: string
  nama_provinsi: string
  jalan_domisili: string
  nama_kecamatan_domisili: string
  nama_kabupaten_domisili: string
  nama_provinsi_domisili: string
  bakat_talent: string
  tanggal_wawancara: string
  sesi: number
  nama_ruang: string
  pilihan1: string
  pilihan2: string
  mapping_bidang_talent: string
  id_data_distribusi_ruangan: number
}

interface DataPrestasiCustom {
  id_data_pendaftaran: number
  nama_jenis_prestasi: string
  nama_jenjang_prestasi: string
  nama_grup_prestasi: string
  nama_capaian_prestasi: string
  lembaga_pemberi_prestasi: string
  tahun_prestasi: string
  path_bukti_prestasi: string
}

interface KomponenNilai {
  id_ref_komponen_penilaian_talent: number
  kode: string
  nama_ref_parent_komponen: string
  id_ref_parent_komponen_penilaian_talent: number
  nama_komponen: string
  nilai_ver1: number
  nilai_ver2: number
}

interface ParentKomponenNilai {
  kode_parent: string
  nama_ref_parent_komponen: "POTENSI"
  komponen: KomponenNilai[]
}

const getDetailPesertaTalentscouting = async (id_data_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator/peserta-wawancara-talent/detail-peserta?id_data_pendaftaran=${id_data_pendaftaran}`,
    {
      withCredentials: true,
    }
  )
  return response.data?.data
}

export function DataTable<
  TData extends DataPendaftaranPesertaTalentscouting,
  TValue
>({
  columns,
  data,
  paginationData,
  isPending: isPendingDataPendaftaran,
}: DataTableProps<TData, TValue>) {
  const [sorting, setSorting] = useState<SortingState>([])
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({})
  const [rowSelection, setRowSelection] = useState({})

  const [searchParams] = useSearchParams()

  const tanggalWawancaraParams = searchParams.get("tanggal_wawancara") || ""
  const sesiParams = searchParams.get("sesi") || ""
  const statusPenilaianParams = searchParams.get("status")
  // const ids_uk = searchParams.get("ids_uk")

  const [showFilter, setShowFilter] = useState(false)
  const [showDetail, setShowDetail] = useState(false)
  const [selectedIdDataPendaftaran, setSelectedIdDataPendaftaran] = useState<
    string | null
  >(null)

  const [searchQuery, setSearchQuery] = useState(
    searchParams.get("search") || ""
  )
  const debouncedQuery = useDebounce(searchQuery, 1000)
  const navigate = useNavigate()
  const location = useLocation()

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    onColumnFiltersChange: setColumnFilters,
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    onRowSelectionChange: setRowSelection,
    state: {
      sorting,
      columnFilters,
      columnVisibility,
      rowSelection,
    },
  })

  // const { data: listJalurJenis } = useQuery({
  //   queryKey: ["listJalurJenis"],
  //   queryFn: getListJalurJenis,
  // })
  // const ids_ref_jalur_jenis_array = ids_ref_jalur_jenis?.split("-")
  // const listJalurJenisAktifFilter =
  //   listJalurJenis?.filter((item: JalurJenis) => {
  //     return ids_ref_jalur_jenis_array?.includes(
  //       String(item.id_ref_jalur_jenis)
  //     )
  //   }) || []

  // const { data: listUnitkerja } = useQuery({
  //   queryKey: ["listUnitkerja"],
  //   queryFn: getListUnitkerja,
  // })
  // const listProdi = listUnitkerja?.filter((unitkerja: Unitkerja) => {
  //   return unitkerja.unitkerja_group_key == "5" && unitkerja.is_active
  // })
  // const ids_uk_array = ids_uk?.split("-")
  // const listProdiAktifFilter =
  //   listProdi?.filter((item: Unitkerja) => {
  //     return ids_uk_array?.includes(String(item.uk_id))
  //   }) || []

  const { data: detailPeserta, isPending: isPendingDetailPeserta } = useQuery<{
    pewawancaraKe: number
    dataPendaftaran: DataPendaftaranCustom
    dataPrestasi: DataPrestasiCustom[]
    dataNilai: ParentKomponenNilai[]
  }>({
    queryKey: ["detailPesertaTalentScouting", selectedIdDataPendaftaran],
    queryFn: () =>
      getDetailPesertaTalentscouting(selectedIdDataPendaftaran || ""),
    enabled: !!selectedIdDataPendaftaran,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search)

    if (debouncedQuery) {
      // if (params.get("search") !== debouncedQuery) {
      //   params.delete("page");
      // }

      if (
        params.get("search") !== debouncedQuery ||
        params.get("page") !== "1"
      ) {
        params.set("search", debouncedQuery)
        navigate(`${location.pathname}?${params.toString()}`, {
          replace: true,
        })
      }
    } else {
      if (params.has("search") || params.get("page") !== "1") {
        params.delete("search")
        navigate(`${location.pathname}?${params.toString()}`, {
          replace: true,
        })
      }
    }
  }, [debouncedQuery, navigate, location.pathname, location.search])

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 py-4">
        <div className="flex-1 flex items-center gap-3">
          <Input
            autoFocus
            placeholder="Filter by nomor pendaftaran, nama lengkap, nik, email, nomor handphone..."
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            className="max-w-sm"
          />
          <Button
            variant={
              tanggalWawancaraParams || sesiParams ? "default" : "outline"
            }
            className="flex items-center gap-x-3"
            onClick={() => setShowFilter(true)}
          >
            Filter
            <LuListFilter />
          </Button>
          <div className="flex items-center overflow-hidden rounded-full border cursor-pointer">
            <div
              className={`py-2 px-4 ${
                !statusPenilaianParams
                  ? "bg-black/90 text-white rounded-full"
                  : "hover:bg-secondary"
              }`}
              onClick={() => {
                searchParams.delete("status")

                navigate(`${location.pathname}?${searchParams.toString()}`)
              }}
            >
              Semua
            </div>
            <div
              className={`py-2 px-4 ${
                statusPenilaianParams === "sudah"
                  ? "bg-black/90 text-white rounded-full"
                  : "hover:bg-secondary"
              }`}
              onClick={() => {
                searchParams.set("status", "sudah")

                navigate(`${location.pathname}?${searchParams.toString()}`)
              }}
            >
              Sudah dinilai
            </div>
            <div
              className={`py-2 px-4 ${
                statusPenilaianParams === "belum"
                  ? "bg-black/90 text-white rounded-full"
                  : "hover:bg-secondary"
              }`}
              onClick={() => {
                searchParams.set("status", "belum")

                navigate(`${location.pathname}?${searchParams.toString()}`)
              }}
            >
              Belum dinilai
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="ml-auto">
                Columns
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {table
                .getAllColumns()
                .filter((column) => column.getCanHide())
                .map((column) => {
                  return (
                    <DropdownMenuCheckboxItem
                      key={column.id}
                      className="capitalize"
                      checked={column.getIsVisible()}
                      onCheckedChange={(value) =>
                        column.toggleVisibility(!!value)
                      }
                    >
                      {column.id}
                    </DropdownMenuCheckboxItem>
                  )
                })}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      {isPendingDataPendaftaran ? (
        <div className="flex flex-col gap-y-3">
          {Array(10)
            .fill(null)
            .map((_, index) => {
              return <SkeletonRow key={index} />
            })}
        </div>
      ) : (
        <div className="border rounded-xl">
          <Table>
            <TableHeader>
              {table.getHeaderGroups().map((headerGroup) => {
                return (
                  <TableRow key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <TableHead key={header.id}>
                          {header.isPlaceholder
                            ? null
                            : flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                        </TableHead>
                      )
                    })}
                  </TableRow>
                )
              })}
            </TableHeader>
            <TableBody>
              {table.getRowModel().rows?.length ? (
                table.getRowModel().rows.map((row) => (
                  <TableRow
                    key={row.id}
                    data-state={row.getIsSelected() && "selected"}
                  >
                    {row.getVisibleCells().map((cell, index) => {
                      if (index == 1)
                        return (
                          <TableCell>
                            <Button
                              onClick={() => {
                                setShowDetail(true)
                                setSelectedIdDataPendaftaran(
                                  row.original?.id_data_pendaftaran
                                )
                              }}
                            >
                              Lihat Detail
                            </Button>
                          </TableCell>
                        )
                      return (
                        <TableCell key={cell.id}>
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    className="h-24 text-center"
                  >
                    No results.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}

      <br />
      <div>
        <Pagination table={table} paginationData={paginationData} />
      </div>

      <Modal show={showFilter} onClose={() => setShowFilter(false)} width="2xl">
        <FormFilter closeModal={() => setShowFilter(false)} />
      </Modal>

      <DetailPeserta
        show={showDetail}
        onClose={() => setShowDetail(false)}
        detailPeserta={detailPeserta}
        isPending={isPendingDetailPeserta}
      />
    </div>
  )
}
